export const groupConstante = Object.freeze({
  GROUP_STATUS_NONE: 1,
  GROUP_STATUS_PENDING: 2,
  GROUP_STATUS_VALID: 3,
});
